// extracted by mini-css-extract-plugin
module.exports = {"button":"_2ZXV1f","disabled":"_2Af_ne","link":"_1tCrJG","regular":"_3hoTb6","active":"_33Fp_R","xs":"A__0I0","sm":"_1UAzsf","lg":"_3p1rHL"};